import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import type { ErrorComponentProps } from '@tanstack/react-router';

import { EmptyState } from '@/components/app/empty-state';
import { Button } from '@/components/ui/button';

import { ApiError } from './api';

export function RouteNotFound() {
    return (
        <EmptyState title="Not found" description="This page does not exist." />
    );
}

export function RouteError({ error, reset }: ErrorComponentProps) {
    const { reset: resetQueries } = useQueryErrorResetBoundary();
    if (error instanceof ApiError && error.status === 404) {
        return <RouteNotFound />;
    }
    return (
        <EmptyState
            title="Something went wrong"
            description={
                error instanceof Error ? error.message : 'Unknown error'
            }
        >
            <Button
                variant="outline"
                className="cursor-pointer"
                onClick={() => {
                    resetQueries();
                    reset();
                }}
            >
                Try again
            </Button>
        </EmptyState>
    );
}
